import { render, staticRenderFns } from "./chat-message-merchant-order-details.vue?vue&type=template&id=18872681&scoped=true"
import script from "./chat-message-merchant-order-details.vue?vue&type=script&lang=js"
export * from "./chat-message-merchant-order-details.vue?vue&type=script&lang=js"
import style0 from "./chat-message-merchant-order-details.vue?vue&type=style&index=0&id=18872681&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18872681",
  null
  
)

export default component.exports